import { render, staticRenderFns } from "./TradeDetailWindow.vue?vue&type=template&id=34e121f0&scoped=true&"
import script from "./TradeDetailWindow.vue?vue&type=script&lang=js&"
export * from "./TradeDetailWindow.vue?vue&type=script&lang=js&"
import style0 from "./TradeDetailWindow.vue?vue&type=style&index=0&id=34e121f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e121f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e121f0')) {
      api.createRecord('34e121f0', component.options)
    } else {
      api.reload('34e121f0', component.options)
    }
    module.hot.accept("./TradeDetailWindow.vue?vue&type=template&id=34e121f0&scoped=true&", function () {
      api.rerender('34e121f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/booking/TradeDetailWindow.vue"
export default component.exports